/**
 * Analytics Provider Component
 * Handles initialization of Cloudflare Analytics and page tracking
 */

import React from 'react';
import { useAnalyticsPageTracking, useAnalyticsInit } from '../hooks/useAnalytics';

interface AnalyticsProviderProps {
  children: React.ReactNode;
}

export function AnalyticsProvider({ children }: AnalyticsProviderProps) {
  // Initialize analytics on app startup
  useAnalyticsInit();
  
  // Track page views automatically
  useAnalyticsPageTracking();

  return <>{children}</>;
}

// Default export for convenience
export default AnalyticsProvider;
